import { useAuth } from '../../../context/auth-context';
import { formatPrice } from '../../../utils';

interface MsjProps {
    alreadyJoined?: string;
    reservedPlayer?: number;
    maxCapacity?: number;
    guestsCount?: number;
    timeGame?: string;
    alreadyPaid?: string;
    totalPaid?: number;
    guests?: string;
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function Msj(props: MsjProps): JSX.Element {
    const { reservedPlayer, maxCapacity, alreadyJoined, guestsCount, timeGame, guests, totalPaid } = props;
    const reserved = reservedPlayer === maxCapacity;
    const auth = useAuth();
    let alert = '';
    if (parseInt(guests) < guestsCount) {
        const total = guestsCount - parseInt(guests);
        alert = `, Eliminaste ${total} invitado${total > 1 ? 's' : ''}`;
    } else if (parseInt(guests) > guestsCount) {
        // alert = `, Agregaste ${parseInt(guests) - guestsCount} invitado`;
    }

    return (
        <>
            {reserved && (
                <div className="flex-col">
                    {timeGame === 'active' && (
                        <p className="text-center text-2xl italic text-sm-rent pt-5">
                            Este juego alcanzó su maxima capacidad de jugadores {reservedPlayer} / {maxCapacity}
                        </p>
                    )}
                </div>
            )}
            {timeGame === 'inactive' && (
                <div className="flex-col">
                    <p className="text-center text-2xl italic text-red-500 pt-5">La fecha de este partido ya paso</p>
                </div>
            )}
            {alreadyJoined === 'ready' && (
                <div className="flex-col">
                    <div className="text-center text-2xl italic text-sm-rent pt-5 pb-5">
                        {auth && auth.user && auth.user.firstName + ' ' + auth.user.lastName + ', '} ya estás
                        participando{' '}
                        {guestsCount > 0 && alert === '' ? (
                            <b>
                                con {guestsCount} amigo{guestsCount > 1 && 's'}
                            </b>
                        ) : (
                            <b>{alert}</b>
                        )}{' '}
                        {totalPaid && totalPaid > 0 ? ' ya realisaste un pago por ' + formatPrice(totalPaid, 0) : ''}{' '}
                    </div>
                </div>
            )}
        </>
    );
}
